import { render } from "./AddPerson.vue?vue&type=template&id=31e85002&scoped=true"
import script from "./AddPerson.vue?vue&type=script&lang=js"
export * from "./AddPerson.vue?vue&type=script&lang=js"

import "./AddPerson.vue?vue&type=style&index=0&id=31e85002&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31e85002"]])

export default __exports__